module.exports = __webpack_public_path__ + "static/b2c_v1-dffc8a24fa515b8876108064f71013e0.svg";